<template>
    <patient-demographics :patient="patient"
                          :visibility="visibility" />
    <hr>
    <relationship-blocks v-model="goalPlan.relationshipBlocks"
                         :patient-id="patient.id"
                         :edit-state="editState"
                         :flat="flat" 
                         :url-head="urlHead" />
    <hr>
    <demographic-items v-model="goalPlan.demographicItems"
                       :goal-plan-id="goalPlan.goalPlanId"
                       :patient-id="patient.id"
                       :edit-state="editState"
                       :url-head="urlHead" />
</template>

<script setup>
    import { defineEmits, computed } from 'vue';

    import patientDemographics from './PatientDemographics.vue';
    import relationshipBlocks from './RelationshipBlocks.vue';
    import demographicItems from './DemographicItems.vue';

    import { defineProps } from 'vue';

    const props = defineProps({
        modelValue: {
            type: Object,
            default: null
        },
        patient: {
            type: Object,
            default: null
        },
        visibility: {
            type: Object,
            default: null
        },
        editState: {
            type: Number,
            default: 0
        },
        flat: {
            type: Boolean,
            defautl: false
        },
        urlHead: {
            type: String,
            default: null
        }
    });

    const emit = defineEmits(['update:modelValue']);

    const goalPlan = computed({
        get: () => props.modelValue,
        set: newValue => emit("update:modelValue", newValue)
    });
    
</script>